module.exports = {
  /* 01.General */
  "chat.end":"Herbegin jou kletsgesprek",
  "chat.endall":"Beëindig klets",
  "chat.cancel":"Kanselleer",
  "chat.cookie":"Hierdie digitale assistent gebruik koekies om te verseker dat u die beste ervaring kry",
  "chat.learn":"Leer meer",
  "chat.minimize":"Minimaliseer",
  "chat.hide":"Naby",
  "chat.hidebot.text":"Close sal die avatar vir 15 minute laat verdwyn",
  "chat.hidebot":"Maak Bot toe",
  "chat.restart":"Begin oor",
  "switch.language":"Van taal wisselen",
  "switch.property":"Verander eiendom",
  "restart.converstation":"Herbegin omskakeling",
  "chat.endtext":"Is jy seker jy wil die huidige klets beëindig?",
  "check.availabity":"Gaan Beskikbaarheid na",
  "check.availabity.submit":"Indien",
  "check.availabity.cancel":"Kanselleer",
  "check.availabity.adults":"Volwassenes",
  "check.availabity.children":"Kinders",
  "check.availabity.child.age":"Ouderdom - kind",
  "feedback.leave":"Los terugvoer",
  "feedback.leave.message":"Los Boodskap",
};
